<template>
  <div class="page">
    <div class="m-top-box">
      <img src="@/assets/img/home/Groups1048.png" alt="">
      <p>实名认证成功</p>
    </div>
    <div class="m-nav">
      <div class="m-title">
        <span class="m-des">注册信息</span>
      </div>
      <div class="m-item" style="margin-top: 20px"><span>真实姓名</span><p>{{people.realName}}</p></div>
      <div class="m-item"><span>证件号码</span><p>{{people.idCardNum}}</p></div>
    </div>
    <div class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/bcInfo.png" alt=""><span>证件信息</span></div>
      <div class="m-nav1"><span>证件姓名</span><p>{{people.realName}}</p></div>
      <div class="m-nav1"><span>证件号码</span><p>{{people.idCardNum}}</p></div>
      <div class="m-nav1"><span>有效期限</span><p>
        {{people.hasNameAccessExpireStart ? dayjs(people.hasNameAccessExpireStart).format('YYYY-MM-DD') : ''}}
        至
        {{people.hasNameAccessExpireEnd | setTime}}</p></div>
    </div>
    <van-button block class="m-btn-default m-btn" native-type="button" @click="goTo()">返回</van-button>
  </div>
</template>

<script>
  import dayjs from 'dayjs';
  export default {
    components: {},
    data () {
      return {
        people:{}
      }
    },
    created () {
      this.getInfo()
    },
    methods: {
      //    获取个人信息
      getInfo () {
        this.http.postRequest({
          url: 'app/user/getUserInfo',
          msg: {},
          success: (res) => {
            this.people = res.data
          }
        })
      },
      goTo(){
        this.$router.push('/mySelf')
      }
    },
    filters: {
      setTime:(value) =>{
        if (!value) return ''
        let time  = dayjs(value).format()
        let time1 = dayjs('2099-12-31 00:00:00').format()
        if(time == time1){
          return '长期'
        }else {
          return dayjs(value).format('YYYY-MM-DD')
        }
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    background: #F4F6F9;
    padding: 12px;
    .m-top-box{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 60px 0 35px 0;
      >img{
        width: 76px;
        height: 76px;
        margin-bottom: 12px;
      }
      >p{
        color: #457DF9;
        font-size: 16px;
        font-weight: bold;
      }
    }
    .m-nav {
      margin-top: 15px;
      background: #ffffff;
      border-radius: 4px;
      padding: 15px;
      .m-title:before{
        display: inline-block;
        content: '';
        width: 4px;
        height: 18px;
        background: #457DF9;
        border-radius: 2px;
        margin-right: 4px;
      }
      .m-title {
        display: flex;
        align-items: center;
        margin-bottom: 9px;
        .m-des{
          font-size: 15px;
          color: #457DF9;
          font-weight: bold;
        }
      }
      .m-item{
        padding-bottom: 20px;
        display: flex;
        >span{
          display: inline-block;
          width: 90px;
          color: #8D8F93;
        }
        >p{
          flex: 1;
          text-align: right;
        }
      }
    }
    .m-info-box{
      background: #ffffff;
      border-radius: 4px;
      padding: 15px 12px 0 12px;
      margin-top: 18px;
      .m-info-tit{
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        >img{
          width: 16px;
          height: 16px;
        }
        >span{
          color: #2B6CF9;
          font-weight: bold;
          font-size: 15px;
          margin-left: 3px;
        }
      }
      .m-nav1{
        padding-bottom: 20px;
        display: flex;
        >span{
          display: inline-block;
          width: 90px;
          color: #8D8F93;
        }
        >p{
          flex: 1;
          text-align: right;
        }
      }
    }
    .m-btn{
      width: 144px;
      border-radius: 8px;
      background: #ffffff;
      color: #2B6CF9;
      margin: 35px auto;
    }
  }
</style>

